export const gearData = [
  {
    id: "fruity-loops",
    name: "Fruity Loops (FL Studio)",
    category: "DAW",
    type: "Software",
    description: "",
    image: "/images/gear/fruity-loops.jpg",
    current: false,
    url: "https://www.image-line.com/"
  },
  {
    id: "sony-acid",
    name: "Sonic Foundry/Sony Acid Pro",
    category: "DAW",
    type: "Software",
    description: "",
    image: "images/gear/sony-acid-pro.jpg",
    current: false,
    url: "https://en.wikipedia.org/wiki/Acid_Pro"
  },
  {
    id: "cubase",
    name: "Steinberg Cubase",
    category: "DAW",
    type: "Software",
    description: "My DAW of choice since 2022. Currently on Cubase 15. ",
    image: "/images/gear/steinberg-cubase.jpg",
    current: true,
    url: "https://www.steinberg.net/cubase/"
  },
  {
    id: "ms2000r",
    name: "Korg MS2000R",
    category: "Synthesizer",
    type: "Hardware",
    description: "Rackmount version of the Korg MS2000",
    image: "/images/gear/ms2000r.jpg",
    current: false,
    url: "https://www.vintagesynth.com/korg/ms2000"
  },
  {
    id: "ms2000",
    name: "Korg MS2000",
    category: "Synthesizer",
    type: "Hardware",
    description: "",
    image: "images/gear/ms2000.jpg",
    current: false,
    url: "https://www.vintagesynth.com/korg/ms2000"
  },
  {
    id: "microq",
    name: "Waldorf Micro-Q",
    category: "Synthesizer",
    type: "Hardware",
    description: "",
    image: "images/gear/microq.jpg",
    current: false,
    url: "https://www.vintagesynth.com/waldorf/micro-q"
  },
  {
    id: "kontakt",
    name: "Native Instruments Kontakt",
    category: "Virtual Instrument Platform",
    type: "Software",
    description: "Native Instruments Kontakt with Komplete 13.",
    image: "/images/gear/kontakt.jpg",
    current: true,
    url: "https://www.native-instruments.com/en/products/komplete/samplers/kontakt-8/"
  },
  {
    id: "mc303",
    name: "Roland MC-303",
    category: "Groovebox",
    type: "Hardware",
    description: "",
    image: "/images/gear/mc303.jpg",
    current: false,
    url: "https://www.vintagesynth.com/roland/mc-303"
  },
  {
    id: "qy70",
    name: "Yamaha QY70",
    category: "Sequencer",
    type: "Hardware",
    description: "",
    image: "/images/gear/qy70.jpg",
    current: false,
    url: "https://www.synthmania.com/qy70.htm"
  },
  {
    id: "qy10",
    name: "Yamaha QY10",
    category: "Sequencer",
    type: "Hardware",
    description: "",
    image: "/images/gear/qy10.jpg",
    url: "https://en.wikipedia.org/wiki/Yamaha_QY10",
    current: false
  },
  {
    id: "rp3",
    name: "Digitech RP3",
    category: "Pedal",
    type: "Hardware",
    description: "",
    image: "/images/gear/rp3.jpg",
    url: "https://gear-vault.com/digitech-rp3-guitar-effects/",
    current: false
  },
  {
    id: "rp100",
    name: "Digitech RP100",
    category: "Pedal",
    type: "Hardware",
    description: "",
    image: "/images/gear/rp100.jpg",
    url: "https://www.effectsdatabase.com/model/digitech/multi/rp100a#media",
    current: false
  },
  {
    id: "ea1",
    name: "Korg ElecTribe EA-1",
    category: "Groovebox",
    type: "Hardware",
    description: "",
    image: "/images/gear/ea1.jpg",
    url: "https://www.vintagesynth.com/korg/electribe-ea-1",
    current: false
  },
  {
    id: "sp202",
    name: "Boss Dr. Sample SP-202",
    category: "Sampler",
    type: "Hardware",
    description: "",
    image: "/images/gear/sp202.jpg",
    url: "https://www.vintagesynth.com/boss/sp-202-dr-sample",
    current: false
  },
  {
    id: "md421",
    name: "Sennheiser MD 421 II",
    category: "Microphone",
    type: "Hardware",
    description: "",
    image: "/images/gear/md421.jpg",
    url: "https://www.sennheiser.com/en-us/catalog/products/microphones/md-421-ii/md-421-ii-000984",
    current: true
  },
  {
    id: "sm57",
    name: "Shure SM57",
    category: "Microphone",
    type: "Hardware",
    description: "",
    image: "",
    url: "https://www.shure.com/en-US/products/microphones/sm57?variant=SM57-LC",
    current: true
  },
  {
    id: "tb12",
    name: "Warm Audio Tone Beast TB12",
    category: "Preamp",
    type: "Hardware",
    description: "",
    image: "/images/gear/tb12.jpg",
    url: "https://warmaudio.com/tb12",
    current: true
  },
  {
    id: "c3",
    name: "Hammond C3",
    category: "Organ",
    type: "Hardware",
    description: "Hammond C3 from 1957.",
    image: "/images/gear/c3.jpg",
    url: "https://en.wikipedia.org/wiki/Hammond_organ",
    current: true
  },
  {
    id: "21h",
    name: "Leslie 21H",
    category: "Speaker",
    type: "Hardware",
    description: "",
    image: "/images/gear/21h.jpg",
    url: "https://en.wikipedia.org/wiki/Leslie_speaker",
    current: true
  },
  {
    id: "rocco",
    name: "Reverend Rocco USA",
    category: "Guitar",
    type: "Hardware",
    description: "",
    image: "",
    url: "https://www.revfan.com/Reverend-Rocco.html",
    current: true
  },
  {
    id: "es339",
    name: "Epiphone ES-339",
    category: "Guitar",
    type: "Hardware",
    description: "",
    image: "",
    url: "https://www.gibson.com/products/epiphone-es-339-cherry",
    current: true
  },
  {
    id: "taylor",
    name: "Taylor Acoustic Guitar",
    category: "Guitar",
    type: "Hardware",
    description: "",
    image: "",
    url: "https://www.taylorguitars.com/guitars/acoustic/browse",
    current: true
  },
  {
    id: "jx8p",
    name: "Roland JX-8P",
    category: "Synthesizer",
    type: "Hardware",
    description: "",
    image: "/images/gear/jx8p.jpg",
    url: "https://www.vintagesynth.com/roland/jx-8p",
    current: true
  },
  {
    id: "2600",
    name: "Behringer 2600 Blue Marvin",
    category: "Synthesizer",
    type: "Hardware",
    description: "",
    image: "/images/gear/2600.jpg",
    url: "https://www.behringer.com/product.html?modelCode=0718-ABH",
    current: true
  },
  {
    id: "uad-minimoog",
    name: "UAD Minimoog",
    category: "Virtual Instrument",
    type: "Software",
    description: "",
    image: "/images/gear/minimoog.jpg",
    url: "https://www.uaudio.com/products/moog-minimoog",
    current: true
  },
  {
    id: "uad-electra",
    name: "UAD Electra 88",
    category: "Virtual Instrument",
    type: "Software",
    description: "",
    image: "/images/gear/electra.jpg",
    url: "https://www.uaudio.com/products/electra-88-vintage-keyboard-studio",
    current: true
  },
  {
    id: "battery",
    name: "Native Instruments Battery",
    category: "Sampler",
    type: "Software",
    description: "",
    image: "/images/gear/battery.jpg",
    url: "https://www.native-instruments.com/en/products/komplete/drums/battery-4/",
    current: true
  },
  {
    id: "yamaha-motif-es8",
    name: "Yamaha Motif ES8",
    category: "Synthesizer",
    type: "Hardware",
    description: "",
    image: "/images/gear/motif-es8.jpg",
    url: "https://www.vintagesynth.com/yamaha/motif",
    current: true
  },
  {
    id: "strymon-big-sky",
    name: "Strymon Big Sky",
    category: "Reverb",
    type: "Hardware",
    description: "",
    image: "/images/gear/bigsky.jpg",
    url: "https://www.strymon.net/product/bigsky",
    current: true
  },
  {
    id: "stereoping",
    name: "Stereoping Synth Controller",
    category: "MIDI Controller",
    type: "Hardware",
    description: "",
    image: "/images/gear/stereoping.jpg",
    url: "https://www.stereoping-shop.com/en/Synth-Controller.html",
    current: true
  },
  {
    id: "vital",
    name: "Vital",
    category: "Synthesizer",
    type: "Software",
    description: "",
    image: "/images/gear/vital.jpg",
    url: "https://vital.audio/",
    current: true
  },
  {
    id: "td3",
    name: "Behringer TD-3",
    category: "Synthesizer",
    type: "Hardware",
    description: "",
    image: "/images/gear/td3.jpg",
    url: "https://www.behringer.com/product.html?modelCode=0718-ACF",
    current: true
  },
  {
    id: "tal-vocoder",
    name: "TAL-Vocoder",
    category: "Synthesizer",
    type: "Software",
    description: "",
    image: "/images/gear/tal-vocoder.jpg",
    url: "https://tal-software.com/products/tal-vocoder",
    current: true
  },
  {
    id: "emx1",
    name: "Korg EMX-1",
    category: "Groovebox",
    type: "Hardware",
    description: "",
    image: "/images/gear/emx1.jpg",
    url: "https://www.vintagesynth.com/korg/electribe-mx-emx-1",
    current: true
  },
  {
    id: "tr-rack",
    name: "Korg TR Rack",
    category: "Synthesizer",
    type: "Hardware",
    description: "",
    image: "/images/gear/tr-rack.jpg",
    url: "https://www.vintagesynth.com/korg/trinity",
    current: true
  },
  {
    id: "tx81z",
    name: "Yamaha TX81Z",
    category: "Synthesizer",
    type: "Hardware",
    description: "",
    image: "/images/gear/tx81z.jpg",
    url: "https://www.vintagesynth.com/yamaha/tx81z",
    current: true
  },
  {
    id: "carnaval",
    name: "E-mu Carnaval",
    category: "Synthesizer",
    type: "Hardware",
    description: "",
    image: "/images/gear/carnaval.jpg",
    url: "https://www.vintagesynth.com/e-mu/carnaval",
    current: true
  },
  {
    id: "orbit",
    name: "E-mu Orbit 9090",
    category: "Synthesizer",
    type: "Hardware",
    description: "",
    image: "/images/gear/orbit.jpg",
    url: "https://www.vintagesynth.com/e-mu/orbit-9090",
    current: true
  },
  {
    id: "planet-phatt",
    name: "E-mu Planet Phatt",
    category: "Synthesizer",
    type: "Hardware",
    description: "",
    image: "/images/gear/planet-phatt.jpg",
    url: "https://www.vintagesynth.com/e-mu/planet-phatt",
    current: true
  },
  {
    id: "proteus-2000",
    name: "E-mu Proteus 2000",
    category: "Synthesizer",
    type: "Hardware",
    description: "",
    image: "/images/gear/proteus-2000.jpg",
    url: "https://www.vintagesynth.com/e-mu/proteus-2000",
    current: true
  },
  {
    id: "matrix-1000",
    name: "Oberheim Matrix 1000",
    category: "Synthesizer",
    type: "Hardware",
    description: "",
    image: "/images/gear/matrix-1000.jpg",
    url: "https://www.vintagesynth.com/oberheim/matrix-1000",
    current: true
  },
  {
    id: "mr-rack",
    name: "Ensoniq MR-Rack",
    category: "Synthesizer",
    type: "Hardware",
    description: "",
    image: "/images/gear/mr-rack.jpg",
    url: "https://www.soundonsound.com/reviews/ensoniq-mr",
    current: true
  },
  {
    id: "s4",
    name: "Alesis S4",
    category: "Synthesizer",
    type: "Hardware",
    description: "Rackmount version of QuadraSynth.",
    image: "/images/gear/s4.jpg",
    url: "https://www.vintagesynth.com/alesis/s4",
    current: true
  },
  {
    id: "sq80",
    name: "Ensoniq SQ-80",
    category: "Synthesizer",
    type: "Hardware",
    description: "",
    image: "/images/gear/sq80.jpg",
    url: "https://www.vintagesynth.com/ensoniq/sq-80",
    current: true
  },
  {
    id: "electro2",
    name: "Clavia Nord Electro 2",
    category: "Synthesizer",
    type: "Hardware",
    description: "",
    image: "/images/gear/electro2.jpg",
    url: "https://www.nordkeyboards.com/legacy-products/nord-electro-2/",
    current: true
  },
  {
    id: "osmose",
    name: "Expressive E Osmose",
    category: "Synthesizer",
    type: "Hardware",
    description: "",
    image: "/images/gear/osmose.jpg",
    url: "https://www.expressivee.com/2-osmose",
    current: true
  },
  {
    id: "virus",
    name: "Access Virus TI Desktop",
    category: "Synthesizer",
    type: "Hardware",
    description: "",
    image: "/images/gear/virus.jpg",
    url: "https://www.vintagesynth.com/access/virus-ti",
    current: true
  },
  {
    id: "minibrute",
    name: "Arturia Minibrute",
    category: "Synthesizer",
    type: "Hardware",
    description: "",
    image: "/images/gear/minibrute.jpg",
    url: "https://www.vintagesynth.com/arturia/minibrute",
    current: true
  },
  {
    id: "tr06",
    name: "Roland TR-06",
    category: "Drum Machine",
    type: "Hardware",
    description: "",
    image: "/images/gear/tr-06.jpg",
    url: "https://www.roland.com/us/products/tr-06/",
    current: true
  },
  {
    id: "octatrack",
    name: "Elektron Octatrack",
    category: "Sampler",
    type: "Hardware",
    description: "",
    image: "/images/gear/octatrack.jpg",
    url: "https://www.vintagesynth.com/Elektron/octatrack",
    current: true
  },
  {
    id: "edge",
    name: "Behringer Edge",
    category: "Synthesizer",
    type: "Hardware",
    description: "",
    image: "/images/gear/edge.jpg",
    url: "https://www.behringer.com/product.html?modelCode=0718-ABM",
    current: true
  },
  {
    id: "mega",
    name: "Sonicware Liven Mega",
    category: "Synthesizer",
    type: "Hardware",
    description: "",
    image: "/images/gear/mega.jpg",
    url: "https://sonicware.jp/pages/liven-mega-synthesis",
    current: true
  },
  {
    id: "cydrums",
    name: "Sonicware Cydrums",
    category: "Synthesizer",
    type: "Hardware",
    description: "",
    image: "/images/gear/cydrums.jpg",
    url: "https://sonicware.jp/pages/cydrums",
    current: true
  },
  {
    id: "neutron",
    name: "Behringer Neutron",
    category: "Synthesizer",
    type: "Hardware",
    description: "",
    image: "/images/gear/neutron.jpg",
    url: "https://www.behringer.com/product.html?modelCode=0718-AAB",
    current: true
  },
  {
    id: "me-50",
    name: "Boss ME-50",
    category: "Guitar Pedal",
    type: "Hardware",
    description: "",
    image: "/images/gear/me-50.jpg",
    url: "https://www.boss.info/us/products/me-50/",
    current: true
  },
  {
    id: "dw-8000",
    name: "Korg DW-8000",
    category: "Synthesizer",
    type: "Hardware",
    description: "",
    image: "/images/gear/dw-8000.jpg",
    url: "https://www.vintagesynth.com/korg/dw-8000",
    current: true
  },
  {
    id: "xp-60",
    name: "Roland XP-60",
    category: "Synthesizer",
    type: "Hardware",
    description: "",
    image: "/images/gear/xp-60.jpg",
    url: "https://www.vintagesynth.com/roland/xp-60",
    current: true
  },
  {
    id: "juno2",
    name: "Roland Alpha Juno 2",
    category: "Synthesizer",
    type: "Hardware",
    description: "",
    image: "/images/gear/juno2.jpg",
    url: "https://www.vintagesynth.com/roland/alpha-juno-2",
    current: true
  },
  {
    id: "jp-800",
    name: "Roland JP-8000",
    category: "Synthesizer",
    type: "Hardware",
    description: "",
    image: "/images/gear/jp-8000.jpg",
    url: "https://www.vintagesynth.com/roland/jp-8000",
    current: true
  },
  {
    id: "sr16",
    name: "Alesis SR-16",
    category: "Drum Machine",
    type: "Hardware",
    description: "The drum machine that was used in Pitchblende around 2000-2001 that we nicknamed Julius. He was never late to practice, never complained, and had perfect timing. Unfortunately, like many rock drummers, he died young from a life hard-lived.",
    image: "/images/gear/sr16.jpg",
    current: false,
    url: "https://www.vintagesynth.com/alesis/sr-16"
  },
  {
    id: "v-station",
    name: "Novation V-Station",
    category: "Software Synthesizer",
    type: "Software",
    description: "An early VST software synth based on the K-Station hardware synth. I used this frequently as my go-to for rubbery bass.",
    image: "/images/gear/v-station.jpg",
    current: false,
    url: "https://www.soundonsound.com/reviews/novation-v-station"
  },
  {
    id: "rebirth",
    name: "Propellerhead ReBirth RB-338",
    category: "Software Synthesizer",
    type: "Software",
    description: "Rebirth is a legendary piece of software that emulates the Roland TB-303 bass synthesizer and TR-808 and TR-909 drum machines. This was one of the first pieces of software that we used, and created many Pitchblende tracks with it. It is now available as freeware and still runs on modern computers. ",
    image: "/images/gear/rebirth.jpg",
    current: true,
    url: "https://www.vintagesynth.com/propellerhead-software/rebirth-rb-338"
  },
  {
    id: "cakewalk-sonar",
    name: "Cakewalk SONAR",
    category: "Digital Audio Workstation",
    type: "Software",
    description: "Around 2004, we were feeling the limitations of Fruity Loops and started experimenting with other DAWs including Cakewalk SONAR 3/4. We used it on a few FilterSlut & E-Lusion/Skepsys tracks and took advantage of features not really possible in Fruity Loops such as time-stretching.",
    image: "/images/gear/sonar.jpg",
    current: false,
    url: "https://www.cakewalk.com/sonar"
  },
  {
    id: "nepheton",
    name: "D16 Nepheton",
    category: "Software Drum Machine",
    type: "Software",
    description: "One of the better TR-808 emulators I've used. I've only used version 1 to make loops in FL Studio but apparently version 2 is out now with even more features.",
    image: "/images/gear/nepheton.jpg",
    current: false,
    url: "https://d16.pl/nepheton2"
  },
  {
    id: "camelphat",
    name: "Camel Audio CamelPhat",
    category: "Software Multi-Effect",
    type: "Software",
    description: "CamelPhat was a popular multi-effect plugin used back in the day. Camel Audio was acquired by Apple in 2015 and CamelPhat was re-designed as Phat FX.",
    image: "/images/gear/camelphat.jpg",
    current: false,
    url: "https://equipboard.com/items/camel-audio-camelphat-multi-effect-software-plugin"
  },
  {
    id: "albino",
    name: "Rob Papen Inspiration Soundware Albino",
    category: "Software Synthesizer",
    type: "Software",
    description: "Originally released in 2006, Albino-3 was the result of a collaboration between Virtual Instrument designer Peter Linsener and Dutch sound designer and musician Rob Papen. ",
    image: "/images/gear/albino.jpg",
    current: false,
    url: "https://www.robpapen.com/albino-3-legend.html"
  },
  {
    id: "predator",
    name: "Rob Papen Inspiration Soundware Predator",
    category: "Software Synthesizer",
    type: "Software",
    description: "When it was released, Predator was an impressive software synth that could make interesting drum and bass basses and leads.",
    image: "/images/gear/predator.jpg",
    current: false,
    url: "https://www.robpapen.com/predator.html"
  },
  {
    id: "discovery",
    name: "DiscoDSP Discovery",
    category: "Software Synthesizer",
    type: "Software",
    description: "A great emulation of the Nord Lead 2 that can generate complex and interesting sounds. ",
    image: "/images/gear/discovery.jpg",
    current: false,
    url: "https://www.discodsp.com/discovery/"
  },
  {
    id: "polysix",
    name: "Korg Polysix",
    category: "Software Synthesizer",
    type: "Software",
    description: "Software emulation of the Korg Polysix hardware synth.",
    image: "/images/gear/polysix.jpg",
    current: false,
    url: "https://www.korg.com/us/products/software/kc_polysix/"
  },
  {
    id: "fm8",
    name: "Native Instruments FM7/FM8",
    category: "Software Synthesizer",
    type: "Software",
    description: "My go-to for FM synthesis.",
    image: "/images/gear/fm8.jpg",
    current: true,
    url: "https://www.native-instruments.com/en/products/komplete/synths/fm8/"
  },
  {
    id: "synthetic-drums",
    name: "Native Instruments Synthetic Drums 2",
    category: "Software Drum Library",
    type: "Software",
    description: "Old sample library with electronic drum sounds that can be loaded into Battery or Kontakt.",
    image: "/images/gear/synthetic-drums.jpg",
    current: false,
    url: "https://www.sweetwater.com/store/detail/SynthDrums2--native-instruments-synthetic-drums-2"
  },
  {
    id: "casiotone-7000",
    name: "Casio Casiotone CT 7000",
    category: "Synthesizer",
    type: "Hardware",
    description: "Belonging to my older brother, this was the first keyboard I had access to and learned to play on. The sounds don't hold up and the keybed isn't very good, but it's built like a tank and has really cool features for its time, like chord accompianiment, biometric drum fills and some recording capabilities.",
    image: "",
    current: true,
    url: "https://www.muzines.co.uk/articles/casiotone-ct-7000/5960"
  },
  {
    id: "goldwave",
    name: "GoldWave",
    category: "Audio Editing",
    type: "Software",
    description: "An early audio editing program that Jeff used to master the Boy Magician album in 2002. ",
    image: "/images/gear/goldwave.jpg",
    current: false,
    url: "https://goldwave.com/"
  },
  {
    id: "soundforge",
    name: "Sonic Foundry/Sony Sound Forge",
    category: "Audio Editing",
    type: "Software",
    description: "An easy-to-use but robust audio editing program. It is now owned by Magix but I still use my old Sony version to master tracks.",
    image: "/images/gear/soundforge.jpg",
    current: true,
    url: "https://www.magix.com/us/music-editing/sound-forge/"
  },
  {
    id: "ozone",
    name: "iZotope Ozone 9",
    category: "Mastering",
    type: "Software",
    description: "A comprehensive mastering suite that provides a wide range of tools for audio processing and enhancement.",
    image: "/images/gear/ozone.jpg",
    current: true,
    url: "https://www.izotope.com/en/products/ozone.html"
  }


];